import { React, useEffect, useState } from "react";
import { useParams, useNavigate} from "react-router";
import { getTransactionHistory } from "../customersUtils";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { AddproductWrapper } from "../../Products/ProductsPage.styled";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { GrPrevious, GrNext } from "react-icons/gr";
import TransactionsForm from "../Partials/TransactionsForm";
import { BiArrowBack } from "react-icons/bi";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function SingleTransaction() {
    const navigate = useNavigate();
	const { id, transactionid } = useParams();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const swiper = document.querySelector(".addSwiper").swiper;
		let next = document.getElementById("next");
		next.addEventListener("click", () => {
			swiper.slideNext(800);
		});

		let prev = document.getElementById("prev");
		prev.addEventListener("click", () => {
			swiper.slidePrev(800);
		});

		getTransactionHistory(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else if (res.result) {
					setLoading(false);
					let updatedData = res.result.map((data) => {
						return { ...data, ...data.productId,  objectId: data.objectId};
					});
					let filteredData = updatedData.filter((data) => {
						return data.objectId === transactionid;
					});
					//duplicate check
					if (filteredData.length > 0) {
						setData(filteredData[0]);
					} else {
						setData(filteredData);
					}
				} else {
					setLoading(false);
					toast.error("Unable to fetch transactions history");
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(error);
			});
	}, []);

	return (
		<AddproductWrapper>
           <div onClick={() => navigate(-1)} style={{ color: "#408D94" }} className='flex-start border'>
					<BiArrowBack size={24} />
					<p>Transactions History</p>
				</div>
			<main>
				<div className='LeftSection'>
					<div className='productDetails'>
						<div className='buttons'>
							<button className='absolute-prev' id='prev'>
								<GrPrevious size={28} />
							</button>
							<button className='absolute-next' id='next'>
								<GrNext size={28} />
							</button>
						</div>
						<Swiper
							// navigation={true}
							modules={[Pagination, Autoplay, Navigation]}
							className='addSwiper'
							loop={true}
						>
							{[data?.image, data?.secondImage, data?.thirdImage].map(
								(url, index) => {
									return (
										<SwiperSlide key={index}>
											<img src={url || "/images/placeholder_img.jpg"} />
										</SwiperSlide>
									);
								}
							)}
						</Swiper>
					</div>
				</div>

				<div className='productForm'>
					<TransactionsForm data={data.length >= 0 ? null : data} />
				</div>
			</main>
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AddproductWrapper>
	);
}

export default SingleTransaction;
